import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import CamperService from '../../api/services/CamperService';

import MainPagetitle from '../../layouts/MainPagetitle';
import Select from 'react-select';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import BathroomService from '../../api/services/BathroomService';
import AdminVehicleService from '../../api/services/AdminVehicleService';
import AdminKilometerService from '../../api/services/AdminKilometerService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import { Modal, Button } from 'react-bootstrap';
const AddSubscriptionCamper = () => {
  const navigate = useNavigate();
  const [skills, setSkills] = useState([])
  const [drivingget, setdrivingget] = useState()
  const [kitchenFeature, setKitchenFeature] = useState([])
  const [kitchenData, setkitchenData] = useState();
  const [outdoorFeature, setOutdoorFeature] = useState([])
  const [outdoorData, setoutdoorData] = useState();
  const [fields, setFields] = useState([{ i_title: '', de_i_title: '' }])
  const [isLoading, setisloading] = useState(false);
  const [brandModal, setBrandModal] = useState(false);
  const [living, setLiving] = useState([])
  const [livingData, setlivingData] = useState();

  const [camperFeature, setCamperFeature] = useState([])
  const [featureData, setfeatureData] = useState();

  const [camperService, setCamperService] = useState([])
  const [serviceData, setserviceData] = useState();

  const [camperAccessory, setCamperAccessory] = useState([])

  const [accessoryData, setaccessoryData] = useState();
  const [camperPackages, setCamperPackages] = useState([])
  const [packageData, setpackageData] = useState();

  const [file, setFile] = useState()
  const [backgroundimage, setBackgroundimage] = useState();
  const [gallery, setGallery] = useState([])

  const [pdf, setPdf] = useState()
  const [error, setError] = useState([]);
  const [type, setType] = useState([]);
  const [brand, setBrand] = useState([]);
  const [fuel, setFuel] = useState([]);

  const [driving, setDriving] = useState([]);
  const [kitchen, setKitchen] = useState([]);
  const [outdoor, setOutdoor] = useState([]);
  const [feature, setFeature] = useState([]);
  const [service, setService] = useState([]);
  const [accessory, setAccessory] = useState([]);
  const [packages, setPackages] = useState([]);
  const [livingSleeping, setLivingSleeping] = useState([]);
  const [additionalDetail, setAdditionalDetail] = useState("");
  const [additionalGermanDetail, setAdditionalGermanDetail] = useState("")
  const [faqDetail, setfaqDetail] = useState("");
  const [faqGermanDetail, setfaqGermanDetail] = useState("");
  const [bathroomData, setBathroomData] = useState([]);

  const [bathroomdatas, setbathroomdatas] = useState();
  const [fetchBathroomData, setFetchBathroomData] = useState([]);
  const [fetchvehicleData, setFetchvehicleData] = useState([]);
  const [vehicleData, setVehicleData] = useState([]);
  const [vehicledatas, setvehicledatas] = useState();
  const [fetchkilometerData, setFetchkilometerData] = useState([]);
  const [kilometerData, setKilometerData] = useState([]);
  const [kilometerdatas, setkilometeratas] = useState();
  const [camperData, setCamperdata] = useState([]);
  const [RentCamperId, setRentCamperId] = useState(0);
  const [pdf1, setPdf1] = useState('')
  const [pdf2, setPdf2] = useState('')
  const [pdf3, setPdf3] = useState('')
  const [licensePlates, setLicensePlates] = useState([]);
  
  const params = useParams()
  useEffect(() => {
    if (localStorage.getItem("admintoken")) {
      getCamper();
      getBrand();
      getFuel();
      fetchDriving();
      fetchKitchen();
      fetchOutdoor();
      fetchLivingSleeping();

      fetchFeature();
      fetchService();
      fetchAccessory();
      fetchPackages();
      getType();
      fetchBathroom();
      fetchVehicleroom();
      fetchKilometerroom();
    }
    else {
      navigate('/')
    }
  }, []);
  //camper Rent
  const getCamper = async () => {
    try {
      let camper = await CamperService.index().json();

      var getdata = camper.data.filter((element) => { return element.camper_type_id === 1 })
      setCamperdata(getdata);

      setisloading(false)
    } catch (error) {
      console.log(error);
    }
  };
  // ----------- Camper Inclusive ------------ //
  let addFormFields = () => {
    setFields([...fields, { i_title: '', de_i_title: '' }]);
  }
  let removeFormFields = (i) => {
    let values = [...fields];
    values.splice(i, 1);
    setFields(values)
  }


  const handleEditorChange = (e, editor) => {
    const data = editor.getData()
    setAdditionalDetail(data);
  }
  const handleGermanEditorChange = (e, editor) => {
    const data = editor.getData()
    setAdditionalGermanDetail(data);
  }
  const handleFAQChange = (e, editor) => {
    const data = editor.getData()
    setfaqDetail(data);
  }
  const handleGermanFAQChange = (e, editor) => {
    const data = editor.getData()
    setfaqGermanDetail(data);
  }
  // ----------- get Driving ------------ //
  const fetchDriving = async () => {
    try {
      let driving = await CamperService.d_index().json();

      setDriving(driving.data);
    } catch (error) {
      console.log(error);
    }
  };
  const handleDriving = (skills) => {
    var data = skills.map((element) => { return element.id });
    setdrivingget(data)
    setSkills(skills || [])
  }
  // ----------- get Kitchen ------------ //
  const fetchKitchen = async () => {
    try {
      let outdoor = await CamperService.k_index().json();
      setKitchen(outdoor.data);
    } catch (error) {
      console.log(error);
    }
  };
  const handleKitchen = (kitchenFeature) => {
    var kitchenData = kitchenFeature.map((element) => { return element.id });
    setkitchenData(kitchenData)
    setKitchenFeature(kitchenFeature || [])
  }
  // ----------- get Outdoor ------------ //
  const fetchOutdoor = async () => {
    try {
      let driving = await CamperService.o_index().json();
      setOutdoor(driving.data);
    } catch (error) {
      console.log(error);
    }
  };
  const handleOutdoor = (outdoorFeature) => {

    var outdoorData = outdoorFeature.map((element) => { return element.id });
    setoutdoorData(outdoorData)
    setOutdoorFeature(outdoorFeature || [])
  }
  // ----------- get Living Sleeping  ------------ //
  const fetchLivingSleeping = async () => {
    try {
      let livingSleeping = await CamperService.ls_index().json();
      setLivingSleeping(livingSleeping.data);
    } catch (error) {
      console.log(error);
    }
  };
  const handleLiving = (living) => {

    var livingData = living.map((element) => { return element.id });
    setlivingData(livingData)
    setLiving(living || [])
  }
  // ----------- get Feature  ------------ //
  const fetchFeature = async () => {
    try {
      let feature = await CamperService.feature().json();
      setFeature(feature.data);
    } catch (error) {
      console.log(error);
    }
  };
  const handleFeature = (camperFeature) => {
    var featureData = camperFeature.map((element) => { return element.id });
    setfeatureData(featureData)
    setCamperFeature(camperFeature || [])
  }
  // ----------- get Service  ------------ //
  const fetchService = async () => {
    try {
      let service = await CamperService.service().json();
      setService(service.data);
    } catch (error) {
      console.log(error);
    }
  };
  const handleService = (camperService) => {
    var serviceData = camperService.map((element) => { return element.id });
    setserviceData(serviceData)
    setCamperService(camperService || [])
  }
  const fetchBathroom = async () => {
    try {
      let packagesList = await BathroomService.index().json();
      setFetchBathroomData(packagesList.data);

    } catch (error) {
      console.log(error);
    }
  };
  const handleBathroom = (camperBathroom) => {


    var bathroomdatas = camperBathroom.map((element) => { return element.id })

    setbathroomdatas(bathroomdatas)
    setBathroomData(camperBathroom || [])
  }
  const fetchVehicleroom = async () => {
    try {
      let packagesList = await AdminVehicleService.index().json();
      setFetchvehicleData(packagesList.data);

    } catch (error) {
      console.log(error);
    }
  };
  const handlevehicle = (CamperVehicle) => {

    var vehicledatas = CamperVehicle.map((element) => { return element.id })

    setvehicledatas(vehicledatas)
    setVehicleData(CamperVehicle || [])
  }

  // get Kilometer //
  const fetchKilometerroom = async () => {
    try {
      let packagesList = await AdminKilometerService.index().json();
      setFetchkilometerData(packagesList.data);

    } catch (error) {
      console.log(error);
    }
  };
  const handlekilometer = (kilometerData) => {

    var kilomererdatas = kilometerData.map((element) => { return element.id })

    setkilometeratas(kilomererdatas)
    setKilometerData(kilometerData || [])
  }
  // ----------- get Accessory  ------------ //
  const fetchAccessory = async () => {
    try {
      let accessory = await CamperService.accessory().json();
      setAccessory(accessory.data);
    } catch (error) {
      console.log(error);
    }
  };
  const handleAccessory = (camperAccessory) => {
    var accessoryData = camperAccessory.map((element) => { return element.id });
    setaccessoryData(accessoryData)
    setCamperAccessory(camperAccessory || [])
  }
  // ----------- get Packages  ------------ //
  const fetchPackages = async () => {
    try {
      let packages = await CamperService.package().json();
      setPackages(packages.data);
    } catch (error) {
      console.log(error);
    }
  };
  const handlePackages = (camperPackages) => {
    var packageData = camperPackages.map((element) => { return element.id });
    setpackageData(packageData)
    setCamperPackages(camperPackages || [])
  }


  // ----------- get brands  ------------ //
  const getBrand = async () => {
    try {
      let brands = await CamperService.b_index().json();
      setBrand(brands.data);
    } catch (error) {
      console.log(error);
    }
  };

  // ----------- get fuel  ------------ //
  const getFuel = async () => {
    try {
      let fuel = await CamperService.f_index().json();
      setFuel(fuel.data);
    } catch (error) {
      console.log(error);
    }
  };
  const getType = async () => {
    try {
      let typeList = await CamperService.type_index().json();

      var getData = typeList.data.filter((element) => { return element.type === params.type })

      setType(getData);

    } catch (error) {
      console.log(error);
    }
  };

  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var logo = fileReader.result
      setFile(logo)
    }
  }
  const onFileBackground = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var logo = fileReader.result
      setBackgroundimage(logo)
    }
  }

  const onFileGallery = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var logo = fileReader.result
      setGallery([...gallery, logo]);

    }

    // const tempArr = [];

    // [...e.target.files].forEach(file => {

    //   const fileReader = new FileReader()

    //   fileReader.readAsDataURL(file)

    //   fileReader.onload = () => {
    //     var logo = fileReader.result

    //     tempArr.push(logo)
    //   }
    // });

    // setGallery(tempArr);
  }
  let removeImageFields = (i) => {
    let values = [...gallery];
    values.splice(i, 1);
    setGallery(values)
  }
  const onPdfChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var pdf_url = fileReader.result
      setPdf(pdf_url)
    }
  }
  const onPdfChange1 = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var pdf_url = fileReader.result
      setPdf1(pdf_url)
    }
  }
  const onPdfChange2 = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var pdf_url = fileReader.result
      setPdf2(pdf_url)
    }
  }
  const onPdfChange3 = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var pdf_url = fileReader.result
      setPdf3(pdf_url)
    }
  }
  const handleCamper = (e) => {
    setRentCamperId(e.id)
    handleLicenseShow(e.id)
  }

  const handleLicenseShow = async (id) => {
    try {
      let response = await CamperService.license_plate_list(id).json();
      setLicensePlates(response?.license_plates);
    } catch (error) {
      console.log(error);
    }
  };

  const onSubmitForm = async (event) => {

    event.preventDefault();
    //  if (!event.target.license_plate.value) {
    //   setError("Licence plate is required");
    //   return;
    // }
    const formData = {};
    fields.forEach((field, index) => {
      formData[`${index + 1} i_title`] = field.i_title;
    });
    var camperData = {

      "title": event.target.title.value,
      // "license_plate": event.target.license_plate.value,
      "de_title": event.target.de_title.value,
      "camper_type_id": 2,
      "parent_id": RentCamperId ? RentCamperId : 0,
      "image": file ? file.split(',')[1] : "",
      "gallery": gallery ? gallery : "",
      "background_image": backgroundimage ? backgroundimage.split(',')[1] : "",
      // "inventory": event.target.inventory.value ,
      "inventory": 0,
      "pdf_url": pdf ? pdf.split(',')[1] : "",

      inclusive: fields,
      "camper_price": {
        // "startdate": event.target.startdate.value,
        // "enddate": event.target.enddate.value,
        // "startdate": event.target.startdate.value,
        // "enddate": event.target.enddate.value,
        "startdate": "",
        "enddate": "",
        "price": event.target.price.value ? event.target.price.value : 0,
        "discount_price": 0,
      },
      "month_details": {
        "1": event.target.January.value,
        "2": event.target.February.value,
        "3": event.target.March.value,
        "4": event.target.April.value,
        "5": event.target.May.value,
        "6": event.target.June.value,
        "7": event.target.July.value,
        "8": event.target.August.value,
        "9": event.target.September.value,
        "10": event.target.October.value,
        "11": event.target.November.value,
        "12": event.target.December.value,
      },
      "camper_price_additional": {
        "service_fee": event.target.service_fee.value ? event.target.service_fee.value : 0,
        "regularPrice": event.target.regularPrice.value,
        "salePrice": event.target.salePrice.value,
        "is_offer": event.target.is_offer.value,
      },
      "technical": {
        "model": event.target.model.value,
        "de_model": event.target.de_model.value,
        "year": event.target.year.value,
        "de_year": event.target.de_year.value,
        "brand_id": event.target.brand_id.value,
        "de_brand_id": event.target.de_brand_id.value,
        "fuel_id": event.target.fuel_id.value,
        "de_fuel_id": event.target.de_fuel_id.value,
        "power": event.target.power.value,
        "de_power": event.target.de_power.value,
        "cc": event.target.cc.value,
        "de_cc": event.target.de_cc.value,
        "ees": event.target.ees.value,
        "de_ees": event.target.de_ees.value,
        "milage": event.target.milage.value,
        "de_milage": event.target.de_milage.value,
        "cpkm": event.target.cpkm.value,
        "de_cpkm": event.target.de_cpkm.value,
        "fueltank": event.target.fueltank.value,
        "de_fueltank": event.target.de_fueltank.value,
        "dimentions": event.target.dimentions.value,
        "de_dimentions": event.target.de_dimentions.value,
        "ferry": event.target.ferry.value,
        "de_ferry": event.target.de_ferry.value,
        "bike": event.target.bike.value,
        "de_bike": event.target.de_bike.value,
        "weight": event.target.weight.value,
        "de_weight": event.target.de_weight.value,
        "weight_condition": event.target.weight_condition.value,
        "de_weight_condition": event.target.de_weight_condition.value,
        "trailer_load": event.target.trailer_load.value,
        "de_trailer_load": event.target.de_trailer_load.value,
        "driving_assistance": event.target.driving_assistance.value,
        "de_driving_assistance": event.target.de_driving_assistance.value,
      },


      "driving": drivingget,
      "kitchen": kitchenData,
      "outdoor": outdoorData,
      "living": livingData,
      "package": packageData,
      "cancellationpolicy":"",
      "service": serviceData,
      "accessory": accessoryData,
      "feature": featureData,
      "bathroom": bathroomdatas,
      "vehicle": vehicledatas,
      "kilometer": kilometerdatas,
      "camper_location": {
        "location_id": 1
      },
      "camper_details": {
        "details": additionalDetail,
        "de_details": additionalGermanDetail,
        "sub_title": event.target.sub_title.value,
        "de_sub_title": event.target.de_sub_title.value,
        "video_url": event.target.video_url.value,
        "explanatory_video_url": event.target.explanatory_video_url.value,
        "on_board_basic_equipment": pdf1 ? pdf1.split(',')[1] : "",
        "pick_up_infos": pdf2 ? pdf2.split(',')[1] : "",
        "return_infos": pdf3 ? pdf3.split(',')[1] : "",
        "faq_content": faqDetail,
        "de_faq_content": faqGermanDetail

      }
    }
    
    setisloading(true)
    try {

      let responseData = await CamperService.camperStore(camperData).json()

      if (responseData.status === true) {

        setBrandModal(true)

      }


    } catch (error) {
      console.log(error)
      //setError("Please complete all fields marked with *")

    }
    setisloading(false)

  };

  return (
    <>
      <MainPagetitle mainTitle="Add Subscription Camper" pageTitle={'Add Subscription Camper'} parentTitle={'Home'} />
      <div className="container-fluid">
        <form className="form-valide" onSubmit={onSubmitForm}>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Add Subscription Camper</h4>
                </div>
                <div className="card-body">
                  <div className="row">

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Image <span className="text-danger">*</span></label>
                      <img className="img-drop-area" height={file ? 100 : 0} width={file ? 100 : 0} src={file} alt='' />
                      <input type="file" className="form-control" name='image' id="val-number" onChange={onFileChange} accept="image/png, image/jpeg" />
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-xl-12 mb-3">
                          <label className="form-label" htmlFor="val-suggestions">Camper Gallery  <span className="text-danger">*</span></label>
                          {gallery.length > 0 &&
                            gallery.map((item, index) => {
                              return (
                                <div key={item}>
                                  <img src={item} alt="" height={100} width={100} />
                                  <button type="button" className="button remove mt-3 p-2" onClick={() => removeImageFields(index)}>Remove</button>
                                </div>
                              );
                            })}
                          <input type="file" className="form-control" name='image' id="val-number" onChange={onFileGallery} accept="image/png, image/jpeg" />
                        </div></div></div>

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Background Image <span className="text-danger">*</span></label>
                      <img className="img-drop-area" height={backgroundimage ? 100 : 0} width={backgroundimage ? 100 : 0} src={backgroundimage} alt='' />
                      <input type="file" className="form-control" name='image' id="val-number" onChange={onFileBackground} />
                    </div>
                    {/* <div className="col-xl-12 mb-3" >
                      <label htmlFor="val-username" className="form-label" >Inventory  <span className="text-danger">*</span><span className="text-danger"></span></label>
                      <input type="number" className="form-control" name='inventory' min={0} />
                    </div> */}
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Camper Type<span className="text-danger">*</span></label>


                      <select className="form-control" id="val-skill" name="camper_type_id" disabled>
                        <option value="2">Subscription </option>

                      </select>


                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Rent Vehicle<span className="text-danger">*</span></label>


                      <Select
                        name='camper_id'
                        options={camperData}
                        onChange={handleCamper}
                        getOptionValue={(option) => option.title}
                        getOptionLabel={(option) =>
                          option.title
                        }
                      // value={skills}
                      // isMulti
                      />



                    </div>
                     {licensePlates.map((plate, index) => (
                      <div className="col-xl-12 mb-3" key={index}>
                        <label htmlFor={`license_plate_${index}`} className="form-label">
                          License plate {licensePlates.length > 1 ? `${index + 1}` : ''}<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name='license_plate'
                          id={`license_plate_${index}`}
                          value={plate?.license_plate}
                          onChange={(e) => {
                            const updated = [...licensePlates];
                            updated[index] = e.target.value;
                            setLicensePlates(updated);
                          }}
                          readOnly
                        />
                      </div>
                    ))}

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12 col-xxl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Additional Detail</h4>
                </div>
                <div className="card-body custom-ekeditor">

                  <div className="col-xl-12 mb-3">
                    <label htmlFor="val-username" className="form-label" >English Sub Title<span className="text-danger">*</span></label>
                    <input type="text" className="form-control" name='sub_title' />
                  </div>
                  <div className="col-xl-12 mb-3">
                    <label htmlFor="val-username" className="form-label" >German Sub Title<span className="text-danger">*</span></label>
                    <input type="text" className="form-control" name='de_sub_title' />
                  </div>
                  <div className="col-xl-12 mb-3">
                    <label htmlFor="val-username" className="form-label" >Video Url (Embeded URL)<span className="text-danger">*</span></label>
                    <input type="text" className="form-control" name='video_url' />
                  </div>
                  <div className="col-xl-12 mb-3">
                    <label htmlFor="val-username" className="form-label" >Pdf Upload<span className="text-danger">*</span></label>
                    <input type="file" className="form-control" name='pdf_url' accept=".pdf" onChange={onPdfChange} />
                    {pdf ? <iframe src={pdf} width={150} height={150} /> : ''}
                  </div>
                  <div className="col-xl-12 mb-3">
                    <label htmlFor="val-username" className="form-label" >English Details<span className="text-danger">*</span></label>
                    <CKEditor
                      editor={ClassicEditor}
                      name="details"
                      onChange={handleEditorChange}
                    />
                  </div>
                  <div className="col-xl-12 mb-3">
                    <label htmlFor="val-username" className="form-label" >German Details<span className="text-danger">*</span></label>
                    <CKEditor
                      editor={ClassicEditor}
                      name="de_details"
                      onChange={handleGermanEditorChange}
                    />
                  </div>
                  <div className="col-xl-12 mb-3">
                    <label htmlFor="val-username" className="form-label" > English FAQ Details<span className="text-danger">*</span></label>
                    <CKEditor
                      editor={ClassicEditor}
                      name="details"
                      onChange={handleFAQChange}
                    />
                  </div>
                  <div className="col-xl-12 mb-3">
                    <label htmlFor="val-username" className="form-label" > German FAQ Details<span className="text-danger">*</span></label>
                    <CKEditor
                      editor={ClassicEditor}
                      name="de_details"
                      onChange={handleGermanFAQChange}
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Camper Subscription Configuration </h4>
                </div>
                <div className="card-body">
                  <div className="row">

                    <div className="col-xl-12 mb-3" style={{ display: "none" }}>
                      <label htmlFor="val-username" className="form-label" >Regular Price<span className="text-danger"></span></label>
                      <input type="text" className="form-control" name='regularPrice' value="0" />
                    </div>
                    <div className="col-xl-12 mb-3" style={{ display: "none" }}>
                      <label htmlFor="val-username" className="form-label" >Sale Price<span className="text-danger"></span></label>
                      <input type="text" className="form-control" name='salePrice' value="0" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Service Price<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='service_fee' />
                    </div>
                    <div className="mb-3" style={{ display: "none" }}>
                      <label htmlFor="val-username" className="form-label" >Is Offer<span className="text-danger"></span></label>
                      <input type="checkbox" className="form-control" name='is_offer' />

                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Price<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='price' />
                    </div>
                    {/* <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Start Date<span className="text-danger">*</span></label>
                      <input type="date" className="form-control" name='startdate' />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >End Date<span className="text-danger">*</span></label>
                      <input type="date" className="form-control" name='enddate' />
                    </div> */}
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >January<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='January' />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >February<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='February' />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >March<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='March' />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >April<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='April' />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >May<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='May' />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >June<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='June' />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >July<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='July' />
                    </div>

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >August<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='August' />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >September<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='September' />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >October<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='October' />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >November<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='November' />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >December<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='December' />
                    </div>

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Explanatory Video Url(Embeded)</label>
                      <input type="text" className="form-control" name='explanatory_video_url'

                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Guide</label>

                      <input type="file" className="form-control" name='on_board_basic_equipment' accept=".pdf" onChange={onPdfChange1}
                      />
                      {pdf1 ? <iframe src={pdf1} width={150} height={150} /> : ''}

                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Pick-Up Infos</label>

                      <input type="file" className="form-control" name='pick_up_infos' accept=".pdf" onChange={onPdfChange2}

                      />
                      {pdf2 ? <iframe src={pdf2} width={150} height={150} /> : ''}
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Return Infos</label>

                      <input type="file" className="form-control" name='return_infos' accept=".pdf" onChange={onPdfChange3}

                      />
                      {pdf3 ? <iframe src={pdf3} width={150} height={150} /> : ''}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title"> Camper Inclusive</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-12 mb-3">
                      
                      {fields.map((element, index) => {
                        return (
                          <div key={index}>
                            <label htmlFor="val-username" className="form-label" >English Title</label>
                            <input type="text" required className="form-control mt-2" name="i_title"
                              onChange={(e) => {
                                const updatedFields = [...fields];
                                updatedFields[index].i_title = e.target.value;

                                setFields(updatedFields);
                              }}
                              value={element.i_title}
                            />
                            <label htmlFor="val-username" className="form-label" >German Title</label>
                            <input type="text" required className="form-control mt-2" name="de_i_title"
                              onChange={(e) => {
                                const updatedFields = [...fields];
                                updatedFields[index].de_i_title = e.target.value;

                                setFields(updatedFields);
                              }}
                              value={element.de_i_title}
                            />
                            {
                              index ?
                                <button type="button" className="button remove mt-3 p-2" onClick={() => removeFormFields(index)}>Remove</button>
                                : null
                            }

                          </div>
                        );
                      })}

                      <button className="button add mt-3 p-2 " type="button" onClick={addFormFields}>Add</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          


          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">English Camper Technicals</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Model<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='model' />
                    </div>

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Fuel type<span className="text-danger">*</span></label>
                      <select className="form-control" id="val-skill" name="fuel_id">
                        {fuel.map((row, index) =>
                          <option key={index} value={row.id}>{row.title} </option>
                        )}
                      </select>

                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Brand<span className="text-danger">*</span></label>
                      <select className="form-control" id="val-skill" name="brand_id">
                        {brand.map((row, index) =>
                          <option key={index} value={row.id}>{row.title} </option>
                        )}
                      </select>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Year of manufacture<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='year' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Power<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='power' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Displacement<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='cc' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Chassis<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='milage' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Emission Standard<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='ees' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Fuel consumption per 100 km<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='cpkm' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Fuel tank<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='fueltank' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Vehicle dimensions (length / width / height)<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='dimentions' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Vehicle age<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='ferry' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Length including bike rack for ferry booking<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='bike' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Maximum permissible weight<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='weight' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Weight in road-ready condition (+/- 5 %)<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='weight_condition' placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Trailer load (unbraked/braked)<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='trailer_load' placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Driving assistance<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='driving_assistance' placeholder="" />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">German Camper Technicals</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Modell<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_model' />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Kraftstoffart<span className="text-danger">*</span></label>
                      <select className="form-control" id="val-skill" name="de_fuel_id">
                        {fuel.map((row, index) =>
                          <option key={index} value={row.id}>{row.de_title} </option>
                        )}
                      </select>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Marke<span className="text-danger">*</span></label>
                      <select className="form-control" id="val-skill" name="de_brand_id">
                        {brand.map((row, index) =>
                          <option key={index} value={row.id}>{row.de_title} </option>
                        )}
                      </select>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Baujahr<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_year' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Leistung<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_power' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Hubraum<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_cc' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Chassis<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_milage' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Abgasnorm<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_ees' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Kraftstoffverbrauch pro 100 km<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_cpkm' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Kraftstofftank Fassungsvermögen<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_fueltank' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Fahrzeugmaße l/b/h (ohne Spiegel)<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_dimentions' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Fahrzeugalter<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_ferry' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Längenangabe bei Fährbuchung inkl. Fahrradträger<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_bike' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Zulässiges Gesamtgewicht<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_weight' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Masse in fahrbereitem Zustand (+/- 5 %)<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_weight_condition' placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Anhängelast (ungebremst/gebremst)<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_trailer_load' placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Fahrassistenz<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_driving_assistance' placeholder="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>






          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Camper Features</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Driving<span className="text-danger">*</span></label>
                      <Select
                        name='driving_id'
                        options={driving}
                        onChange={handleDriving}
                        getOptionValue={(option) => option.title}
                        getOptionLabel={(option) =>
                          option.title
                        }
                        value={skills}
                        isMulti
                      />

                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Kitchen<span className="text-danger">*</span></label>
                      <Select
                        name="kitchen_id"
                        options={kitchen}
                        onChange={handleKitchen}
                        getOptionValue={(option) => option.title}
                        getOptionLabel={(option) =>
                          option.title
                        }
                        value={kitchenFeature}
                        isMulti
                      />

                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Outdoor area<span className="text-danger">*</span></label>
                      <Select
                        name="outdoor_id"
                        options={outdoor}
                        onChange={handleOutdoor}
                        getOptionValue={(option) => option.title}
                        getOptionLabel={(option) =>
                          option.title
                        }
                        value={outdoorFeature}
                        isMulti
                      />

                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Living & Sleeping<span className="text-danger">*</span></label>
                      <Select
                        name="living_sleeping_id"
                        options={livingSleeping}
                        onChange={handleLiving}
                        getOptionValue={(option) => option.title}
                        getOptionLabel={(option) =>
                          option.title
                        }
                        value={living}
                        isMulti
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Features<span className="text-danger">*</span></label>
                      <Select
                        name="feature_id"
                        options={feature}
                        onChange={handleFeature}
                        getOptionValue={(option) => option.title}
                        getOptionLabel={(option) =>
                          option.title
                        }
                        value={camperFeature}
                        isMulti
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Service<span className="text-danger">*</span></label>
                      <Select
                        name="service_id"
                        options={service}
                        onChange={handleService}
                        getOptionValue={(option) => option.title}
                        getOptionLabel={(option) =>
                          option.title
                        }
                        value={camperService}
                        isMulti
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Accessory<span className="text-danger">*</span></label>
                      <Select
                        name="accessory_id"
                        options={accessory}
                        onChange={handleAccessory}
                        getOptionValue={(option) => option.title}
                        getOptionLabel={(option) =>
                          option.title
                        }
                        value={camperAccessory}
                        isMulti
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Packages<span className="text-danger">*</span></label>
                      <Select
                        name="package_id"
                        options={packages}
                        onChange={handlePackages}
                        getOptionValue={(option) => option.title}
                        getOptionLabel={(option) =>
                          option.title
                        }
                        value={camperPackages}
                        isMulti
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Bathroom<span className="text-danger">*</span></label>
                      <Select
                        name="bathroom_id"
                        options={fetchBathroomData}
                        onChange={handleBathroom}
                        getOptionValue={(option) => option.title}
                        getOptionLabel={(option) =>
                          option.title

                        }
                        value={bathroomData}
                        isMulti
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Vehicle<span className="text-danger"></span></label>
                      <Select
                        name="vehical_id"
                        options={fetchvehicleData}
                        onChange={handlevehicle}
                        getOptionValue={(option) => option.title}
                        getOptionLabel={(option) =>
                          option.title

                        }
                        value={vehicleData}
                        isMulti
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Kilometer<span className="text-danger"></span></label>
                      <Select
                        name="kilometer_id"
                        options={fetchkilometerData}
                        onChange={handlekilometer}
                        getOptionValue={(option) => option.title}
                        getOptionLabel={(option) =>
                          option.title

                        }
                        value={kilometerData}
                        isMulti
                      />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div className="text-danger mb-2">{error}</div>
          <div>
            <button type="submit" className="btn btn-primary me-1">Submit</button>
          </div>
        </form>
      </div>
      {isLoading && <LogoAnimationLoader />}
      <Modal centered className="mark-attendence" show={brandModal}>
        <Modal.Header>
          <Modal.Title>Update </Modal.Title>
          <Button variant="" className="btn-close" onClick={() => setBrandModal(false)}></Button>
        </Modal.Header>
        <Modal.Body>Create Camper Successfully!!!.</Modal.Body>
        <Modal.Footer>
          <Link className="btn btn-primary" to={`/admin/camper_subscription`} variant="danger light" onClick={() => setBrandModal(false)}>Close</Link>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default AddSubscriptionCamper;